import React from 'react';
import { Link } from 'react-router-dom';
import BRAND, { copyright } from '../../constants/brand';
import {
  PRODUCT_LINKS, AUDIENCE_LINKS, COMPANY_LINKS, LEGAL_LINKS
} from '../../constants/siteMap';
import { marketplaceSentence } from './MarketplaceStatus';

// The marketing footer. Every link comes from constants/siteMap.js, which the
// navigation bar and the signed-in footer also read — they used to keep three
// separate lists, and those lists disagreed about which pages exist.
//
// `anchorPrefix` lets the #anchor links work both on the landing page (bare
// #features) and on a standalone page like /privacy (/#features, so the
// browser goes back to the landing page first instead of hunting for an
// anchor that is not on the page you are reading).
function Column({ title, children }) {
  return (
    <div>
      <p className="text-white text-sm font-semibold mb-3">{title}</p>
      <ul className="space-y-2 text-sm">{children}</ul>
    </div>
  );
}

export default function PublicFooter({ anchorPrefix = '' }) {
  const render = (l) => (
    <li key={l.to || l.hash}>
      {l.to
        ? <Link to={l.to} className="hover:text-white">{l.label}</Link>
        : <a href={`${anchorPrefix}${l.hash}`} className="hover:text-white">{l.label}</a>}
    </li>
  );

  return (
    <footer className="bg-gray-900 text-gray-400">
      <div className="max-w-7xl mx-auto px-4 py-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-8">
        <div className="sm:col-span-2 lg:col-span-1">
          <h4 className="text-white font-bold mb-1">{BRAND.name}</h4>
          <p className="text-xs mt-3 leading-relaxed">{BRAND.description}</p>
          {/* Named, not linked — there is no page behind "Amazon". And named
              with their real state: this line used to read "Files for Amazon ·
              Flipkart · Meesho · Myntra" while the export engine accepted one
              of the four. */}
          <p className="text-[11px] mt-4 text-gray-500">{marketplaceSentence()}</p>
        </div>

        <Column title="Product">{PRODUCT_LINKS.map(render)}</Column>
        <Column title="Who it&apos;s for">{AUDIENCE_LINKS.map(render)}</Column>
        <Column title="Company">{COMPANY_LINKS.map(render)}</Column>
        <Column title="Legal">{LEGAL_LINKS.map(render)}</Column>
      </div>

      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center
                        justify-between gap-2 text-xs">
          <span>{copyright()}</span>
          <span className="text-gray-500">
            {BRAND.legalEntity} · {BRAND.country}
          </span>
        </div>
      </div>
    </footer>
  );
}
